<template lang="pug">
div
  v-text-field(
    :value="value"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    :hide-details="hideDetails"
    :label="label"
    :error="error"
    :error-messages="errorMessages"
    :data-test="dataTest"
  )
    <template v-slot:append>
      v-menu(
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      )
        template(v-slot:activator="{ on }")
          v-icon(v-on="on") mdi-calendar-today
        v-date-picker(
          v-model="datepickerValue"
          no-title
          scrollable
          @change="onValueChange"
          :min="minDate"
        )
    </template>
</template>

<script>
import { DATE_DEFAULT_REGXP } from '../../util/const'
import { dateFormating, convertToDefaultDateFormat, convertToDefaultBackendFormat } from '../../util'
export default {
  props: {
    value: {
      required: true
    },
    label: String,
    error: Boolean,
    errorMessages: String,
    hideDetails: {
      type: Boolean,
    },
    min: String,
    dataTest: String,
    allowedMinutes: {
      type: Function,
      default: m => m % 10 === 0,
    },
    onlyFutureDate: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    menu: false
  }),

  computed: {
    datepickerValue: {
      get() {
        if(DATE_DEFAULT_REGXP.test(this.value)) return dateFormating(this.value).join('-')
        return null
      },
      set(val) {
        this.$emit('input', convertToDefaultDateFormat(val))
      }
    },

    minDate() {
      if(this.onlyFutureDate) return  convertToDefaultBackendFormat(new Date(Date.now()))
      return null
    }
  },

  methods: {
    onValueChange() {
      this.menu = false;
      this.$emit('change');
    }
  }
}
</script>
